import { render, staticRenderFns } from "./BedsImage.vue?vue&type=template&id=353f9694&"
import script from "./BedsImage.vue?vue&type=script&lang=js&"
export * from "./BedsImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports